import React from 'react';
import { CreateAgencyWizardStepProps } from '../types';
import AgencyTeamForm, { AgencyTeamFormModel } from '../../../components/agency-team-form/AgencyTeamForm';

const AgencyTeamWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback(({
    agents,
  }: AgencyTeamFormModel) => {
    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit({
      ...initialData,
      agentIds: agents.map(({ id }) => id!),
    }, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  return (
    <AgencyTeamForm
      initialValues={{
        // we are not fetching existing agents cause we are inside the wizard to create a new agency
        // so there won't be any
        agents: [],
      }}
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyTeamWizardStep;
